import { render, staticRenderFns } from "./stepThree.vue?vue&type=template&id=48be8e0a&lang=pug&"
import script from "./stepThree.vue?vue&type=script&setup=true&lang=js&"
export * from "./stepThree.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports